import { MainApi } from "./MainApi";
import { AffiliateCodeCommissionCheckerParam, CreateOrderParam } from "../types/order";
import {CouponCodeRequestDTO} from "../types/couponCode";

export class OrderApi {
  static baseUrl = `${MainApi.urlPrefix}/user/orders`;
  static dcasUrlPrefix = `${MainApi.dcasUrlPrefix}/user`;
  static dcasSimpleBaseUrl = `${MainApi.dcasSimpleUrlPrefix}/user`;
  static couponCodeUrl = `${MainApi.urlPrefix}/coupon-code`;

  static postOrder = (orderParam: CreateOrderParam) => () => MainApi.api.post(`${OrderApi.baseUrl}`, orderParam);

  static getOrder = (orderIdx: number) => () => MainApi.api.get(`${OrderApi.dcasUrlPrefix}/orders/${orderIdx}`);
  
  static getRefundOrder = (orderIdx: number) => () => MainApi.api.get(`${OrderApi.baseUrl}/${orderIdx}/refunds`);

  // mypage 결제 내역
  static getOrders = (orderIdx: number) => () => MainApi.api.get(`${OrderApi.baseUrl}?page=${orderIdx}&size=4`);

  static getAffiliateCode = (code: string) => () =>
    MainApi.api.get(`${MainApi.urlPrefix}/affiliate-codes?code=${encodeURIComponent(code)}`);

  static checkAffiliateCodeCommission = (param: AffiliateCodeCommissionCheckerParam) => () =>
    MainApi.api.post(`${OrderApi.baseUrl}/check-affiliate-commission`, param);

  static getSimpleTestDiscountCode = (code: string) => () =>
      MainApi.api.post(`${OrderApi.dcasSimpleBaseUrl}/discount-code?code=${encodeURIComponent(code)}`);

  static checkSimpleTestCodePermission = (code: string) => () =>
      MainApi.api.get(`${OrderApi.dcasSimpleBaseUrl}/discount-code?code=${encodeURIComponent(code)}`);

  static getCouponCode = (body: CouponCodeRequestDTO) => () =>
      MainApi.api.post(`${OrderApi.couponCodeUrl}`, body);
}
